module.exports = __webpack_public_path__ + "8b13b24a7e9625a12bf99ef880993a4d.jpg";